module.exports = __webpack_public_path__ + "img/frase_balao_4.2e9cd663.svg";